import styled from 'styled-components';

export const SubNavHeaderContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    gap: 8px;
`

export const SubNavItem = styled.div`
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 100px;
    border: 1px solid rgba(255,255,255,0.4);
    background-color: ${({ $isActive }) => ($isActive ? 'rgba(255,255,255,0.2)' : 'transparent')};
    transition: all 0.3s ease;

    &:hover {
        background-color: rgba(255,255,255,0.2);
    }
`